<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    max-width="80%"
    v-if="role('admin', 'safetyRepresentative') && comparePeoplePoint"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2 py-5">
        <v-row no-gutters>
          <v-col>
            <span>
              {{ $t("import.importTitle") }}
            </span>
          </v-col>
          <v-col cols="auto">
            <v-btn size="small" icon variant="text" @click="hide">
              <v-icon size="large" class="text-grey-darken-1">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="px-0 pb-0">
        <v-data-table
          v-for="(category, index) in results"
          :key="index"
          :headers="headers"
          :items="comparePeoplePoint[category]"
          footer.page-text="page text"
          :footer-props="{
            'items-per-page-text': `${$t('employees.footer.itemsPerPage')}`,
            'items-per-page-all-text': `${$t('employees.footer.all')}`,
          }"
          class="table-striped pb-3"
          :no-data-text="$t('import.noData')"
          show-select
          v-model="selectedItems[category]"
          item-key="employeeId"
        >
          <template v-slot:top>
            <v-row no-gutters>
              <v-col class="pa-4">
                <div class="subtitle-1">
                  {{ $t(`import.${category}.title`) }}
                </div>
                <div class="text--secondary">
                  {{ $t(`import.${category}.subtitle`) }}
                </div>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="importMissing" :loading="loading">
          {{ $t("import.importEmployees") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ComparePeoplePointQuery from "@/graphql/queries/import/ComparePeoplePoint.gql";
import ImportMissingMutation from "@/graphql/mutation/import/ImportMissingPeoplePoint.gql";

export default {
  props: ["show"],
  data() {
    return {
      loading: false,
      results: ["missingEmployees", "employeesToActivate", "extraEmployees"],
      selectedItems: {
        missingEmployees: [],
        employeesToActivate: [],
        extraEmployees: [],
      },
    };
  },
  computed: {
    ...mapGetters(["role"]),
    headers() {
      return [
        {
          text: this.$t("import.employeeId"),
          value: "employeeId",
          class: "text-uppercase subheading",
        },
        {
          text: this.$t("import.firstName"),
          value: "firstName",
          class: "text-uppercase subheading",
        },
        {
          text: this.$t("import.lastName"),
          value: "lastName",
          class: "text-uppercase subheading",
        },
        {
          text: this.$t("profile.email"),
          value: "email",
          class: "text-uppercase subheading",
        },
        {
          text: this.$t("import.managerId"),
          value: "managerId",
          class: "text-uppercase subheading",
        },
      ];
    },
  },
  methods: {
    importMissing() {
      const employeeInputs = this.selectedItems.missingEmployees.map((emp) => ({
        id: parseInt(emp.employeeId),
        employeeId: emp.employeeId,
        firstName: emp.firstName,
        lastName: emp.lastName,
        tags: [],
        modeIds: [],
        personalInformation: {
          personalCode: "",
          address: "",
          phone: "",
        },
      }));

      const employeeIdsToActivate = this.selectedItems.employeesToActivate.map(
        (emp) => emp.id
      );

      const employeeIdsToDeactivate = this.selectedItems.extraEmployees.map(
        (emp) => emp.id
      );

      this.$apollo
        .mutate({
          mutation: ImportMissingMutation,
          variables: {
            employeeInputs,
            employeeIdsToActivate,
            employeeIdsToDeactivate,
          },
        })
        .then((res) => {
          this.hide();
          this.$emit("imported", res.data.importMissingPeoplePoint);
        });
    },
    hide() {
      this.$emit("close-comparison");
    },
  },
  apollo: {
    comparePeoplePoint: {
      query: ComparePeoplePointQuery,
      skip() {
        return !this.show;
      },
    },
  },
};
</script>
